module.exports = __webpack_public_path__ + "static/img/ind_ban_04.b105f020.jpeg";